import script from "./SupplierPICDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierPICDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SupplierPICDropdown.vue?vue&type=style&index=0&id=05f2ff4f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f2ff4f"]])

export default __exports__